import * as React from "react";

function ContactIcon({ type }) {
  if (type === "email") {
    return (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 5.5h18v13H3z" />
        <path d="m4 7 8 6 8-6" />
      </svg>
    );
  }

  if (type === "x") {
    return (
      <svg className="is-fill" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231 5.45-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
      </svg>
    );
  }

  return (
    <svg className="is-fill" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M13.5 22v-9h3l.45-3.5H13.5V7.26c0-1.01.28-1.7 1.74-1.7H17.1V2.43a25 25 0 0 0-2.7-.14c-2.67 0-4.5 1.63-4.5 4.63V9.5H7v3.5h2.9v9h3.6Z" />
    </svg>
  );
}

function Contact() {
  return (
    <section className="trps-section trps-paper" id="Contact">
      <div className="trps-wrap">
        <h2 className="trps-h">お問い合わせ</h2>
        <p className="trps-sub">
          メール、X、Facebookよりお気軽にお問い合わせください。
        </p>

        <div className="trps-contact-grid">
          <nav className="trps-contact-links" aria-label="お問い合わせ先">
            <a
              className="trps-contact-link"
              href="mailto:traps.robocup@gmail.com"
            >
              <span className="trps-contact-link__main">
                <span className="trps-contact-link__icon" aria-hidden="true"><ContactIcon type="email" /></span>
                <span className="trps-contact-link__copy">
                  <strong>traps.robocup@gmail.com</strong>
                </span>
              </span>
            </a>
            <a
              className="trps-contact-link"
              href="https://twitter.com/TRAPS_RoboCup"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="trps-contact-link__main">
                <span className="trps-contact-link__icon" aria-hidden="true"><ContactIcon type="x" /></span>
                <span className="trps-contact-link__copy">
                  <strong>@TRAPS_RoboCup</strong>
                </span>
              </span>
            </a>
            <a
              className="trps-contact-link"
              href="https://www.facebook.com/profile.php?id=61559205031125"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="trps-contact-link__main">
                <span className="trps-contact-link__icon" aria-hidden="true"><ContactIcon type="facebook" /></span>
                <span className="trps-contact-link__copy">
                  <strong>TRAPS RoboCup</strong>
                </span>
              </span>
            </a>
          </nav>

          <div className="trps-contact-embed">
            <h3>Facebook</h3>
            <iframe
              title="facebook"
              src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2Fprofile.php%3Fid%3D61559205031125&tabs=timeline&width=500&height=560&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId=371445781271070"
              width="100%"
              height="560"
              style={{ border: "none", overflow: "hidden", display: "block" }}
              allowFullScreen={true}
              allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Contact;
